<!--
 Filter Container Mobile
 Show facets and handle filter communication for mobile devices.
 devs@droxit.de
 Copyright (c) 2021 droxIT GmbH
-->

<template>
  <div id="rocketsearch-tags-container" class="col">
    <div class="rocketsearch-no-tags-label" v-if="!anyFiltersSet()"><span>{{$t('no_filters_set')}}</span></div>
    <div class="rocketsearch-tags-list">
      <span class="rocketsearch-tags-list-item active" v-for="(entry, opt_index) in transformFilters(filters)" :key="opt_index">
        <span class="rocketsearch-tags-text">{{entry.showValue}}</span>
        <span class="rocketsearch-tags-text__close" @click="removeFilter(entry.name, entry.value)"> X</span>
      </span>
    </div>
  </div>
</template>

<script>

  /*
  * The Result Container, showing preview or all results for a search term
  */
  export default {
    name: 'TagsContainerMobile',
    props: {
      filters: Object
    },
    methods: {
      transformFilters(filters){
        // transform filters dictionary to flat array of objects with name and value entries

        var vue=this;

        var arr = Object.entries(filters).map( function(x) {
          var name = x[0];
          var vals = x[1];
          /*
            to allow a different value to show as tag, we use a different showVals array
            this is currently used for ranges to not only show the value but a `from x` tag instead
            since ranges are objects and not arrays, we need to set vals to the object keys array
          */
          var showVals = x[1];

          if (!Array.isArray(vals)) {
            showVals = Object.entries(vals).map(entry => vue.$t('range_facet_'+entry[0], [entry[1]]));
            vals = Object.keys(vals);
          }
          return vals.map(function(val, i) { return {name: name, value: val, showValue: showVals[i]};});
        });

        return arr.flat(1);
      },
      removeFilter(filter_name, opt_index){
        if(!Object.keys(this.filters).includes(filter_name)) {
          return;
        }

        var selected = this.filters[filter_name];

        if (Array.isArray(selected)) {
          selected.splice(opt_index, 1);
        } else {
          delete selected[opt_index];
        }

        this.$root.$emit('RocketFilterSelectedEvent', { name: filter_name, options: selected });
      },
      anyFiltersSet(){
        return Object.keys(this.filters).length > 0;
      }
    }
  }
</script>
